import { useAppDispatch } from "src/common/state/hooks";
import ModalStandard from "../../../common/components/Modal/ModalStandard";
import { closeStandardModal } from "../../../common/state/slice/modal/modalSlice";
import { ThemeEditor } from "./ThemeEditor";
import type { IThemeInfo } from "src/model/model";
import Alert from "../../../common/components/Alert/Alert";

const ModalThemeEditor = ({
  title,
  themeId = 0,
  createthemeWithThisBase = false,
  onCancel,
  onConfirm,
}: {
  title: string;
  themeId?: number;
  createthemeWithThisBase?: boolean;
  onCancel?: () => void | null;
  onConfirm?: (theme: IThemeInfo) => void | null;
}) => {
  const dispatch = useAppDispatch();

  const onCancelDefault = () => {
    dispatch(closeStandardModal("modalThemeEditor"));
  };

  return (
    <ModalStandard
      id="modalThemeEditor"
      fullScreen={true}
      isStatic
      modalType="standard"
      clickOnBackgroundClose={false}
    >
      <div className="flex w-full">
        <div className="text-center">
          <Alert />
        </div>
        <div className="grow overflow-y-visible ">
          <ThemeEditor
            title={title}
            themeId={themeId}
            createthemeWithThisBase={createthemeWithThisBase}
            onCancel={onCancel ? onCancel : onCancelDefault}
            onConfirm={onConfirm ?? null}
          />
        </div>
      </div>
    </ModalStandard>
  );
};

export default ModalThemeEditor;
